// extracted by mini-css-extract-plugin
export default {"avatar":"zDKTVp","avatarIndication":"RlJpdg","avatarText":"fxFjDK"};